import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=40f8b97e&scoped=true&"
import script from "./Forbidden.vue?vue&type=script&lang=ts&"
export * from "./Forbidden.vue?vue&type=script&lang=ts&"
import style0 from "./Forbidden.vue?vue&type=style&index=0&id=40f8b97e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f8b97e",
  null
  
)

export default component.exports